import withStyles from "@material-ui/core/styles/withStyles";
import { styles } from "./LanguageSelect.css";

import i18n from "i18next";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import React, { Component } from "react";

class LanguageSelect extends Component {
  constructor() {
    super();
    this.state = {
      lang: i18n.language || "en",
    };
    document.documentElement.lang = i18n.language || "en";
  }
  changeL = (event) => {
    this.setState({
      lang: event.target.value,
    });

    i18n.changeLanguage(event.target.value);
    document.documentElement.lang = event.target.value;
  };

  render() {
    const { lang } = this.state;
    return (
      <FormControl variant="outlined">
        <Select 
        disableunderline="true" 
        value={lang} 
        onChange={this.changeL}
        inputProps={{
          id: "selectLanguage",
          "aria-labelledby": "selectLanguage",
        }}
        >
          <MenuItem area-label="English" value={"en"}>
            EN
          </MenuItem>
          <MenuItem area-label="Deutsch" value={"de"}>
            DE
          </MenuItem>
        </Select>
      </FormControl>
    );
  }
}
export default withStyles(styles)(LanguageSelect);
